import { createSlice } from "@reduxjs/toolkit";
import { AUTHENTICATE_USER } from "../constants";

export const authSlice = createSlice({
  name: AUTHENTICATE_USER,
  initialState: {
    isAuthenticated: false,
  },
  reducers: {
    authSliceReducerSlice: (state, action) => {
      const data = {
        ...state,
        isAuthenticated: action.payload,
      };

      return (state = data);
    },
  },
});

export const { authSliceReducerSlice } = authSlice.actions;

export default authSlice.reducer;
